const Operation = {
  before: {
    warranty: 'https://www.tanaka-megane.co.jp/cms/wp-content/uploads/2025/02/hosho_2023.pdf',
    instruction: 'https://www.tanaka-megane.co.jp/cms/wp-content/uploads/2025/02/torisetsu_2023.pdf',
  },
  after: {
    warranty: 'https://www.tanaka-megane.co.jp/cms/wp-content/uploads/2025/02/hosho_2025.pdf',
    instruction: 'https://www.tanaka-megane.co.jp/cms/wp-content/uploads/2025/02/torisetsu_2025.pdf',
  },
}

export default Operation
